export enum OnboardingState {
  /** Artist has not started Stripe Connect onboarding. */
  NotStarted = 0,
  /** Onboarding link has been created but the artist has not completed all requirements. */
  Pending = 1,
  /** Stripe account is created and charges are enabled, but payouts are not yet enabled. */
  ChargesOnly = 2,
  /** Both charges and payouts are enabled; artist is fully onboarded. */
  Complete = 3,
  /** Artist completed onboarding but the account was later restricted by Stripe. */
  Restricted = 4,
}
